import { ReportRecommendation } from '@snapi/types';
import { useState } from 'react';
import { ReportRecommendationCardPdf } from '../report-recommendation-card';

interface ReportRecommendationSummaryPdfProps {
  recommendations: ReportRecommendation[];
  babyName: string;
}

export const ReportRecommendationSummaryPdf = ({
  recommendations,
  babyName,
}: ReportRecommendationSummaryPdfProps) => {
  const [selected, setSelected] = useState<ReportRecommendation | null>(null);

  return (
    <section className="flex flex-col">
      <div className="flex flex-col gap-5 container mb-10">
        <h2 className="flex basis-1/2 text-dark">{`${babyName}'s Nutrition Plan`}</h2>
        <p className="flex basis-1/2">
          {babyName}’s taste buds are developing, and it's important to take it
          slow when introducing new foods! We suggest starting with 2-3 new
          foods per week.
        </p>
      </div>
      <div className="container block">
        <div className="self-center grid gap-7 ">
          {recommendations.map((recommendation) => (
            <ReportRecommendationCardPdf
              key={recommendation.recommendation.name}
              value={recommendation}
              onExpand={() => setSelected(recommendation)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
